<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>Product Sub Category</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <v-switch 
                        v-model="productSubCategoryRequest.requiredAtLeastOneProduct"
                        label="At least one product is mandatory"
                        :value=1
                        color="var(--color__main)"
                    >
                    </v-switch>
                </v-col>
                <v-col 
                    cols="12"
                    lg="6"
                    md="12"
                    sm="12"
                >
                    <v-switch 
                        v-model="productSubCategoryRequest.requiredOnlyOne"
                        label="Must choose only one product"
                        :value=1
                        color="var(--color__main)"
                    >
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col 
                    cols="12"
                    lg="3"
                    md="3"
                    sm="6"
                >
                    <label>Product Category</label>
                    <v-combobox
                        v-model="productSubCategoryRequest.productCategorySelected"
                        :items="listProductCategory"
                        item-text="description"
                        item-value="id"
                        clearable
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col 
                    cols="12"
                    lg="6"
                    md="6"
                    sm="6"
                >
                    <label>Description</label>
                    <v-text-field
                        v-model="productSubCategoryRequest.description" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12"
                    lg="3"
                    md="3"
                    sm="12"
                >
                    <label>Order</label>
                    <v-text-field
                        v-model="productSubCategoryRequest.order"
                        v-mask="'####'" 
                        :rules=[validations.required]
                        single-line
                        outlined
                        dense
                    >
                    </v-text-field>
                </v-col>
            </v-row>

            <ActionButtons
                :request="productSubCategoryRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>

    </v-container>
</template>

<script>
    import { required } from "@/utilities/Rules";
    import Helpers from '@/utilities/Helpers';
    import ActionButtons from "@/components/Layout/ActionButtons";

    export default ({

        mixins: [Helpers],

        components: {
            ActionButtons
        },

        data: () => ({

            validForm: true,

            productSubCategoryRequest: {
                id: 0,
                idProductCategory: 0,
                requiredAtLeastOneProduct: 0,
                requiredOnlyOne: 0,
                description: "",
                order: 1
            },

            listProductCategory: [],

            loading: false,
            
            validations: {
                required: required,
            }
        }),

        props: {
            id: {
                default: 0
            }
        },

        methods: {
            
            async getRegister() {

                if (this.id !== 0) {

                    let response = await this.$store.dispatch("productSubCategoryModule/GetById", this.id);

                    if (response.success) {
                        this.productSubCategoryRequest = response.result;
                    }

                }
            },

            async cancel() {
                this.$router.push({ path: "/product/productSubCategoryList" });
            },

            async getLists() {
                
                this.listProductCategory = await this.$store.dispatch("productCategoryModule/List");
            },

            async save() {

                await this.$refs.form.validate();

                if (this.validForm === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                    return false;
                }
                else {
                    this.loading = true;
                    this.showLoading();

                    this.productSubCategoryRequest.id = this.id;
                    this.productSubCategoryRequest.idProductCategory = this.productSubCategoryRequest.productCategorySelected.id;

                    if (this.productSubCategoryRequest.requiredAtLeastOneProduct === null) {
                        this.productSubCategoryRequest.requiredAtLeastOneProduct = 0;
                    }

                    if (this.productSubCategoryRequest.requiredOnlyOne === null) {
                        this.productSubCategoryRequest.requiredOnlyOne = 0;
                    }

                    const result = await this.$store.dispatch("productSubCategoryModule/CreateUpdate", this.productSubCategoryRequest);

                    if (result.success === true) {
                        this.showToast("success", "Success!", result.message);
                        this.cancel();
                    }
                    else {
                        this.showToast("error", "Warning!", result.message);
                    }

                    this.loading = false;
                    this.hideLoading();
                        
                }
            }
        },

        created() {
            this.showLoading();

            this.getRegister();
            this.getLists();

            this.hideLoading();
        }
    })
</script>